import { config } from "/app.config"
import { logout } from "@/auth/keycloak"

// Failure screen for the boot sequence. This runs when the Vue app could not be
// mounted — Keycloak init failed, or the user fetch never resolved — so it has
// no components, no i18n and no notification mixins to work with. It writes
// plain DOM into the #loading-bg element from public/index.html, replacing the
// spinner that would otherwise animate forever; the styles sit next to that
// spinner in public/loader.css.
//
// Copy is inline English rather than i18n keys because vue-i18n needs Vue, which
// is precisely what failed to start. Every locale in this repo is `en` today, so
// nothing is lost in practice — revisit if a second language is ever added.

const detailOf = (error) => {
  if (!error) {
    return ""
  }

  if (error.response?.status) {
    return `HTTP ${error.response.status}`
  }

  return error.message || String(error)
}

export const showBootError = ({ title, message, error }) => {
  const root = document.getElementById("loading-bg")

  if (!root) {
    return
  }

  const box = document.createElement("div")
  box.className = "boot-error"

  if (config.colors?.primary) {
    box.style.setProperty("--boot-error-primary", config.colors.primary)
  }

  const heading = document.createElement("h1")
  heading.textContent = title

  const description = document.createElement("p")
  description.textContent = message

  const actions = document.createElement("div")
  actions.className = "boot-error-actions"

  const retry = document.createElement("button")
  retry.type = "button"
  retry.className = "boot-error-btn boot-error-btn-primary"
  retry.textContent = "Try again"
  retry.addEventListener("click", () => window.location.reload())

  const signOut = document.createElement("button")
  signOut.type = "button"
  signOut.className = "boot-error-btn"
  signOut.textContent = "Sign out"
  signOut.addEventListener("click", () => logout())

  actions.appendChild(retry)
  actions.appendChild(signOut)

  box.appendChild(heading)
  box.appendChild(description)
  box.appendChild(actions)

  const detail = detailOf(error)

  if (detail) {
    const code = document.createElement("p")
    // textContent, not innerHTML — the detail can carry server-controlled text.
    code.className = "boot-error-detail"
    code.textContent = detail
    box.appendChild(code)
  }

  root.innerHTML = ""
  root.appendChild(box)
  retry.focus()
}
